export default __webpack_public_path__ + "static/nail-salon-logo-small-a56547baeea9fe716f4b70abcba1c61f.svg";